module.exports = __webpack_public_path__ + "src/components/Receipt/question.svg?ea7eb03f";


//////////////////
// WEBPACK FOOTER
// ./src/components/Receipt/question.svg
// module id = 3371
// module chunks = 8